import { confirmEmail } from 'redux/auth/actions';
import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';

import Spinner from 'components/shared/Spinner';
import { parseQueryString } from 'utils/helpers';

const propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({ search: PropTypes.string }).isRequired,
};

const componentDidMount = ({ props }) => {
    const { history, location } = props;
    const { code } = parseQueryString(location.search);

    props.confirmEmail(code).then(() => {
        history.push('/');
    });
};

const render = () => r(Spinner);


export default stitch(
    { componentDidMount, propTypes, render },
    ({ auth }) => ({ isConfirming: auth.get('confirmingEmail') }),
    { confirmEmail }
);



// WEBPACK FOOTER //
// ./src/components/public/Auth/index.js